export type CSMapZoomConfiguration = {
  '': number,
  autocomplete: number,
  current_location: number,
  initial?: number
}

export type CoordinateTypes = keyof CSMapZoomConfiguration

export type CSMapCoordinates = {
  type: CoordinateTypes
  location: {
    latitude: number,
    longitude: number,
  }
}

export type InitialCoordinates = [number, number]

export const COORDINATE_TYPE_ZOOM: CSMapZoomConfiguration = {
  autocomplete: 10,
  ['']: 15,
  current_location: 10,
  initial: 8
}

export type StoreLocatorMobileView = 'list' | 'map'
